;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Image from "next/image"

export default function GroupCard({
  groupPhotoUrl,
  settingInPerson,
  settingVirtual,
  priority = false,
}) {
  const getSettingType = () => {
    if (settingInPerson && settingVirtual) {
      return "Virtual & In-person"
    }
    if (settingInPerson) {
      return "In-person"
    }
    if (settingVirtual) {
      return "Virtual"
    }
    return "None"
  }
  const renderInPersonOrVirtual = () => {
    // settingInPerson
    // settingVirtual
    const locationSettingText = getSettingType()

    return settingInPerson || settingVirtual ? (
      <div
        className={
          "absolute flex justify-center items-center bottom-[10px] right-[19px] bg-[#EEECEC] h-[31px] px-[8px] text-[#565656] rounded-[11px] opacity-[.92]"
        }
      >
        {locationSettingText}
      </div>
    ) : null
  }

  return (
    <div className="relative">
      {groupPhotoUrl ? (
        <Image
          src={groupPhotoUrl}
          height={208}
          width={349}
          className="h-auto max-w-full"
          alt={"group picture"}
          priority={priority}
          style={{
            objectFit: "cover",
            overflow: "hidden",
          }}
        />
      ) : (
        // No photo: neutral placeholder so we never pass an empty src to next/image.
        <div className="h-[208px] w-[349px] max-w-full bg-[#EEECEC]" />
      )}
      {renderInPersonOrVirtual()}
    </div>
  )
}
